import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (window?.console?.error) {
      console.error('LEP React crash:', error, info);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '24px', border: '1px solid #f5c7c7', borderRadius: '10px', background: '#fff1f1', color: '#8f1d1d' }}>
          <h2 style={{ margin: '0 0 10px 0' }}>Portal Error</h2>
          <p style={{ margin: '0 0 14px 0' }}>Something went wrong while rendering the dashboard.</p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{ border: '1px solid transparent', borderRadius: '8px', padding: '8px 12px', fontWeight: 600, background: '#205ec8', color: '#fff', cursor: 'pointer' }}
          >
            Reload Portal
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
